
const digest = 'c2179337625d54358d1c0d85fd3bd6681bab83e179cb8d8e16430fb54f9d8df3';
const classes = {"wrapper":"_wrapper_1hx4n_1","title":"_title_1hx4n_6","subtitle":"_subtitle_1hx4n_10","buttons":"_buttons_1hx4n_13"};
const css = `._wrapper_1hx4n_1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
._wrapper_1hx4n_1 ._title_1hx4n_6 {
  font-weight: 600;
  color: #1665d8;
}
._wrapper_1hx4n_1 ._subtitle_1hx4n_10 {
  font-weight: 600;
}
._wrapper_1hx4n_1 ._buttons_1hx4n_13 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  